<template>
  <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation
    >
    <v-card-text>
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex md12>
            <v-alert
              :value="true"
              v-if="estado_item === 1"
              type="success"
              transition="scale-transition"
            >
              ITEM DISPONIBLE
            </v-alert>
            <v-alert
              :value="true"
              v-if="estado_item === 0"
              type="error"
              transition="scale-transition"
            >
              ITEM OCUPADO
            </v-alert>
            <v-alert
              :value="true"
              v-if="estado_item === -1"
              type="error"
              transition="scale-transition"
            >
              ITEM INEXISTENTE
            </v-alert>
          </v-flex>
        </v-layout>

        <v-layout wrap>
          <v-flex md12 v-if="this.funcionario.item != null">
            <strong>Nro de item :</strong> {{ this.funcionario.item }}
          </v-flex>
          <!-- <v-flex md12 v-if="this.form.nro_item != null" >
          <strong>Nro de item:</strong> {{ this.form.nro_item }}
        </v-flex> -->
          <v-flex md12 v-if="this.funcionario.padres_unidad != null">
            <strong>Dependencia :</strong> {{ this.funcionario.padres_unidad }}
          </v-flex>
          <!-- <v-flex md12 v-if="this.form.padres_unidad != null">
          <strong>Nombre unidad padre:</strong> {{ this.form.padres_unidad }}
        </v-flex> -->
          <v-flex md12 v-if="this.funcionario.unidad != null">
            <strong>Nombre unidad:</strong> {{ this.funcionario.unidad }}
          </v-flex>

          <v-flex md12 v-if="this.funcionario.cargo != null">
            <strong>Cargo:</strong> {{ this.funcionario.cargo }}
          </v-flex>

          <v-flex md6 v-if="this.funcionario.puesto != null">
            <strong>Puesto:</strong> {{ this.funcionario.puesto }}
          </v-flex>

          <v-flex md6 v-if="this.funcionario.sueldo != null">
            <strong>Sueldo:</strong> {{ this.funcionario.sueldo }}
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex md4>
            <v-text-field
              type="date"
              label="Fecha de cambio"
              v-model="form.fecha_desde"
              :rules="$validate(['required'])"
              required
              @change="alertarAprobacion()"
               @input="esFeriadoOFinDeSemana(form.fecha_desde,1)"
            />
          </v-flex>
          <v-flex
            md3
            v-if="this.form.id_estado != 2 && this.form.id_estado != 1 && this.form.id_estado != 64"
          >
            <v-autocomplete
              :items="itemsDisponibles"
              item-text="nro_item"
              item-value="nro_item"
              :rules="$validate(['required'])"
              required
              label="ITEM:"
              :loading="loading"
              @change="cargarDatos()"
              v-model="form.nro_item"
            />
          </v-flex>

          <v-flex md4 v-if="this.form.id_estado != 1 && this.form.id_estado != 64">
            <v-autocomplete
              :items="unidades"
              item-text="nombre_unidad"
              :item-value="val => parseInt(val.id)"
              label="Unidad"
              v-model="form.id_unidad"
              :rules="$validate(['required'])"
              @change="obtenerOrganigrama"
              required
              disabled
            >
              <template v-slot:item="data">
                <v-tooltip left class="tree--rounded">
                  <template v-slot:activator="{ on }">
                    <div v-on="on">
                      {{ data.item.nombre_unidad }}
                    </div>
                  </template>
                  <v-treeview
                    class="white--text pa-1"
                    v-model="tree"
                    :open="[1, 2]"
                    :items="data.item.organigrama"
                    item-key="id"
                  >
                    <template v-slot:prepend="{ item }">
                      <v-icon class="white--text">
                        {{ item.icon }}
                      </v-icon>
                    </template>
                  </v-treeview>
                </v-tooltip>
              </template>
            </v-autocomplete>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex md4 v-if="this.form.id_estado != 1 && this.form.id_estado != 64">
            <v-autocomplete
              :items="cargos"
              item-text="cargo"
              :item-value="val => parseInt(val.id_cargo)"
              label="Cargo"
              v-model="form.id_cargo"
              :rules="$validate(['required'])"
              required
              disabled
            ></v-autocomplete>
          </v-flex>
          <v-flex
            md4
            v-if="this.form.id_estado != 2 && this.form.id_estado != 1 && this.form.id_estado != 64"
          >
            <v-autocomplete
              :items="puestos"
              item-text="denominacion"
              :item-value="val => parseInt(val.id)"
              label="Puesto"
              v-model="form.id_puesto"
              :rules="$validate(['required'])"
              disabled
            ></v-autocomplete>
          </v-flex>
          <v-flex md4 v-if="this.form.id_estado != 1 && this.form.id_estado != 64">
            <v-autocomplete
              :items="itemsDisponibles"
              item-text="sueldo"
              :item-value="val => val.sueldo"
              :rules="$validate(['required'])"
              required
              disabled
              label="Sueldo"
              :loading="loading"
              v-model="form.sueldo"
            />
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>

    <v-card-actions>
      <small class="error--text text-required"
        >* Los campos son obligatorios</small
      >
      <v-spacer></v-spacer>
      <v-btn @click.native="close()">
        <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
      </v-btn>
      <v-btn
        v-show="!fecha_futuro"
        color="primary"
        type="submit"
        :loading="loading"
        :disabled="!valid "
      >
        <v-icon dark>check</v-icon> {{ $t("common.save") }}
      </v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  mixins: [validate],
  props: [
    "id_tipo_justificacion",
    "funcionario",
    "unidades",
    "cargos",
    "puestos",
    "data"
  ],
  data() {
    return {
      valid: false,
      loading: false,
      estado_item: null,
      form: this.data,
      itemsDisponibles: [],
      obtenerOrganigrama: [],
      tree: [],
      fecha_desde_original: this.data.fecha_desde,
      fecha_futuro:false,
      bandera_fecha:false,
    };
  },
  async mounted() {
    await this.obtenerItemsDisponibles();
    if (this.form.editar) {
      await this.obtenerSueldo();
    }
  },
  methods: {
    async esFeriadoOFinDeSemana(fecha,valor){},
        async esFeriadoOFinDeSemanaVerificar(fecha, valor) {
      try {
        if (valor == 1) {
          this.bandera_fecha = false;
        }
        let usuario = this.$storage.get("user");
        if (!fecha && valor == 1) {
          this.$message.info("Fecha inválida ",fecha);
          this.bandera_fecha = true;
          return true;
        } else {
          //verificando que la fecha es o no dia habil
          let respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta: "SELECT general.fn_cuenta_finde_feriado_por_persona('${fecha}', '${fecha}', ${usuario.id_persona})"){
                  respuesta
                }
              }
            `,
          });
          if (respuesta.runQuery.respuesta) {
            respuesta =
              respuesta.runQuery.respuesta[0]
                .fn_cuenta_finde_feriado_por_persona;

            if (respuesta == 1 && valor == 1) {
              this.$message.info(`La fecha ${this.$moment(fecha).format('DD/MM/YYYY')} cae en fin de semana o feriado`);
              this.bandera_fecha = true;
              return true;
            }

            return false;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },

    alertarAprobacion() {
      if (this.form.id_estado == 64) {
        if (
          this.$moment() >= this.$moment(this.form.fecha_desde, "YYYY-MM-DD")
        ) {
          this.$alert(
            "Selecciono la fecha actual o una fecha pasada, por lo tanto la movilidad se aprobara si la guarda"
          );
        }
      }
      if (this.form.id_estado == 1 || this.form.id_estado == 53) {
        if (
          this.$moment() <= this.$moment(this.form.fecha_desde, "YYYY-MM-DD")
        ) {
          this.$alert(
            "Selecciono una fecha a futuro, por lo cual no puede guardar la movilidad, ya que fue aprobada"
          );
          this.fecha_futuro=true
        }
        else{
          this.fecha_futuro=false
        }
      }
    },
    async save() {
      if (this.form.editar) {
        try {
          let validacion_fecha=await this.esFeriadoOFinDeSemanaVerificar(this.form.fecha_desde,1)
          if (validacion_fecha) {
            return;
          }
          if (this.$refs.form.validate() && !this.fecha_futuro) {
            this.loading = true;
            let id_puesto = this.form.id_puesto;
            let id_cargo = this.form.id_cargo;
            let id_tipo_justificacion = this.id_tipo_justificacion;
            let user = this.$storage.get("user");
            console.log(`
                query{
                  runQuery(consulta: "SELECT movilidad.fn_modifica_movilidad_interinato_estado(${this.funcionario.id_persona}, ${user.id}, '${this.form.fecha_desde}', ${this.form.id_unidad}, ${id_puesto}, ${id_cargo}, ${this.form.nro_item}, ${id_tipo_justificacion},null,${this.form.id_estado})"){
                    respuesta
                  }
                }
              `)
            let respuesta = await this.$service.graphql({
              query: `
                query{
                  runQuery(consulta: "SELECT movilidad.fn_modifica_movilidad_interinato_estado(${this.funcionario.id_persona}, ${user.id}, '${this.form.fecha_desde}', ${this.form.id_unidad}, ${id_puesto}, ${id_cargo}, ${this.form.nro_item}, ${id_tipo_justificacion},null,${this.form.id_estado})"){
                    respuesta
                  }
                }
              `
            });
            respuesta =
              respuesta.runQuery.respuesta[0]
                .fn_modifica_movilidad_interinato_estado;
            let resps = respuesta.split("|");
            let correcto = resps[0];
            if (correcto === "1") {
              this.$message.success(resps);
              this.close();
            } else {
              this.$message.error(resps);
              this.loading = false;
            }
          }
        } catch (error) {
          return console.log(error);
        }
      } else {
        try {
          let validacion_fecha=await this.esFeriadoOFinDeSemanaVerificar(this.form.fecha_desde,1)
          if (validacion_fecha) {
            return;
          }
          if (this.$refs.form.validate()) {
            this.loading = true;
            let user = this.$storage.get("user");
             console.log(`
                query{
                  runQuery(consulta: "SELECT movilidad.fn_alta_movilidad(${this.funcionario.id_persona}, ${user.id}, '${this.form.fecha_desde}', ${this.form.id_unidad}, ${this.form.id_puesto}, ${this.form.id_cargo}, ${this.form.nro_item}, ${this.id_tipo_justificacion})"){
                    respuesta
                  }
                }
              `)
            let res = await this.$service.graphql({
              query: `
                query{
                  runQuery(consulta: "SELECT movilidad.fn_alta_movilidad(${this.funcionario.id_persona}, ${user.id}, '${this.form.fecha_desde}', ${this.form.id_unidad}, ${this.form.id_puesto}, ${this.form.id_cargo}, ${this.form.nro_item}, ${this.id_tipo_justificacion})"){
                    respuesta
                  }
                }
              `
            });

            let resp = res.runQuery.respuesta[0].fn_alta_movilidad;

            let resps = resp.split("|");
            let correcto = resps[0];
            if (correcto === "1") {
              this.$message.success();
            } else {
              this.$message.error(resps);
            }
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    async validaItem() {
      try {
        this.loading = true;
        if (this.form.nro_item !== "") {
          let res = await this.$service.graphql({
            query: `
							query {
								runQuery(consulta: "SELECT movilidad.fn_valida_item(${this.form.nro_item})"){
									respuesta
								}
							}
						`
          });
          this.estado_item = res.runQuery.respuesta[0].fn_valida_item;
          let res2 = await this.$service.graphql({
            query: `
							query {
								items(nro_item: "${this.form.nro_item}"){
									rows{
										id
									}
								}
							}
						`
          });
          if (res2.items.rows.length > 0) {
            this.form.id_item = parseInt(res2.items.rows[0].id);
          }
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async obtenerSueldo() {
      this.form.nro_item=this.data.nro_item+""
      const elemento = this.itemsDisponibles.find(
        item => item.nro_item == this.form.nro_item
      );
          console.log("+++",elemento)
      if (elemento) {
        this.form.funcionario.sueldo = elemento.sueldo;
      } else {
        this.form.funcionario.sueldo = await this.obtenerItemX(
          this.funcionario.item
        );
      }
    },
    cargarDatos() {
       console.log("elem;",this.itemsDisponibles)
      const elemento = this.itemsDisponibles.find(
        item => item.nro_item == this.form.nro_item
      );
      console.log("elem;",elemento)
      this.form.id_unidad = elemento.id_unidad;
      this.form.id_cargo = elemento.id_cargo;
      this.form.id_puesto = elemento.id_puesto;
      // const puesto = this.puestos.find(item => item.id === this.form.id_puesto);
      // if (puesto) {
      //   this.form.id_puesto = elemento.id_puesto;
      // } else {
      //   this.form.id_puesto = null;
      // }
      this.form.sueldo = elemento.sueldo;
      this.form.nro_item = elemento.nro_item;
    },
    async obtenerItemX(nro_item) {
      try {
        console.log(`
                query{
                  runQuery(consulta: "SELECT movilidad.fn_obtiene_sueldo_por_item(${parseInt(
                    nro_item
                  )})"){
                    respuesta
                  }
                }
              `)
        let res = await this.$service.graphql({
          query: `
                query{
                  runQuery(consulta: "SELECT movilidad.fn_obtiene_sueldo_por_item(${parseInt(
                    nro_item
                  )})"){
                    respuesta
                  }
                }
              `
        });    
        if (res.runQuery.respuesta[0].fn_obtiene_sueldo_por_item) {
           return res.runQuery.respuesta[0].fn_obtiene_sueldo_por_item;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async obtenerItemsDisponibles() {
      try {
        this.loading = true;
        let res = await this.$service.graphql({
          query: `
            query{
              vItemCargos(libre: 1){
                rows{
                   id_item
                  nro_item
                  nombre_unidad
                  cargo
                  id_cargo
                  sueldo
                  libre
                  id_unidad
                  padres_unidad
                  id_puesto
                  puesto
                }
              }
            }
          `
        });
        this.itemsDisponibles = res.vItemCargos.rows;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    close() {
      this.form = {};
      this.loading = false;
      this.valid = false;
      this.$bus.$emit("closeDialogCrearMovilidad");
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/movilidad/components/CambioItem.vue